/**
 * Wording for the "Match Format" (best-of-N) selector.
 *
 * Racket sports scored in games (badminton, table tennis, squash, racquetball,
 * pickleball) say "games"; volleyball and tennis say "sets". Individual sports
 * say "player" (or "pair" for doubles) instead of "team".
 */

const GAME_BASED_SPORTS = ["badminton", "table tennis", "ping pong", "squash", "racquetball", "pickleball"];

/**
 * @param {string} sportName
 * @param {{ isIndividual?: boolean, playFormat?: string }} [opts]
 * @returns {{ unit: string, units: string, side: string }}
 */
export function getMatchFormatTerms(sportName, { isIndividual = false, playFormat = "singles" } = {}) {
  const name = String(sportName || "").toLowerCase();
  const gameBased = GAME_BASED_SPORTS.some((s) => name.includes(s));
  let side = "team";
  if (isIndividual) side = playFormat === "doubles" ? "pair" : "player";
  return {
    unit: gameBased ? "game" : "set",
    units: gameBased ? "games" : "sets",
    side,
  };
}

/**
 * Labels and help text for the best-of-N options.
 */
export function getMatchFormatLabels(sportName, opts = {}) {
  const { unit, units, side } = getMatchFormatTerms(sportName, opts);
  const Unit = unit.charAt(0).toUpperCase() + unit.slice(1);
  const Units = units.charAt(0).toUpperCase() + units.slice(1);
  const name = String(sportName || "").toLowerCase();
  const lastTarget = name.includes("volleyball") ? "15" : "the normal target";
  return {
    options: {
      best_of_1: `1 ${Unit} (Best of 1)`,
      best_of_3: `Best of 3 ${Units}`,
      best_of_5: `Best of 5 ${Units}`,
    },
    help: {
      best_of_1: `Every match is a single ${unit}. First to reach the point target wins immediately.`,
      best_of_3: `First ${side} to win 2 ${units} wins the match. Up to 3 ${units} played.`,
      best_of_5: `First ${side} to win 3 ${units} wins the match. Up to 5 ${units} — last ${unit} to ${lastTarget} points.`,
    },
  };
}
